<template>
  <div class="selection__grid">
    <div v-for="item in selection" :key="item.id" class="selection__item">
      <div v-if="item.nominee && !item.suggestion">
        <h3>{{ item.nominee.category.name }}</h3>
        <div class="selection__card__image__contained" :style="stylesForNominee(item.nominee)">
          <b style="color: #faf9f6">{{ item.nominee.name }}</b>
          <b style="color: #faf9f6">{{ item.nominee.platform }}</b>
          <a
            class="button button--small"
            :href="urlForCategory(item.nominee.category)"
            @click.prevent="clearCategory(item.nominee.category)"
          >
            Stem wijzigen
          </a>
        </div>
      </div>

      <div v-if="item.suggestion && !item.nominee && !isFirstRound">
        <h3>{{ getCategoryName(item.suggestion.categoryId) }}</h3>
        <div class="selection__card__image__contained" :style="stylesForSuggestion()">
          <b style="color: #faf9f6">{{ item.suggestion.suggestionName }}</b>
          <a
            class="button button--small"
            :href="urlForCategory(findCategoryById(item.suggestion.categoryId))"
            @click.prevent="clearCategory(findCategoryById(item.suggestion.categoryId))"
          >
            Stem wijzigen
          </a>
        </div>
      </div>

      <div v-if="item.suggestion && !item.nominee && isFirstRound">
        <h3>{{ getCategoryName(item.suggestion.categoryId) }}</h3>
        <div class="selection__card__image__contained" :style="stylesForSuggestion()">
          <b style="color: #faf9f6">{{ item.suggestion.suggestionName }}</b>
          <a
            class="button button--small"
            href="/#/"
            @click.prevent="clearSuggestionCategory(item.suggestion.categoryId)"
          >
            Stem wijzigen
          </a>
        </div>
      </div>
    </div>
    <div v-if="canAdd && !isFirstRound()" class="selection__item">
      <router-link class="selection__card selection__card--empty" :to="getOpenCategory()">
        <span>Stem op nog een categorie</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import isFirstRound from '../util/firstRound'

export default {
  name: 'Selection',

  methods: {
    isFirstRound,
    getOpenCategory() {
      const category = this.categories.find((category) => !this.usedCategoryIds.includes(category.id))
      if (!category) {
        return {
          name: 'home',
        }
      }

      return {
        name: 'category',
        params: {
          categorySlug: category.slug,
        },
      }
    },

    findCategoryById(categoryId) {
      return this.categories.find((category) => category.id === categoryId)
    },

    clearCategory(category) {
      this.$store.dispatch('clearCategory', {
        categoryId: category.id,
      })

      this.$router.push(this.urlForCategory(category)).catch((err) => console.warn(err))
    },

    clearSuggestionCategory(categoryId) {
      this.$store.dispatch('clearCategory', {
        categoryId: categoryId,
      })
      this.$router.push({
        name: 'home',
      })
    },

    urlForCategory(category) {
      return {
        name: 'category',
        params: {
          categorySlug: category.slug,
        },
      }
    },

    stylesForNominee(nominee) {
      return nominee.image
        ? {
            backgroundImage: `linear-gradient(0deg, #121212, transparent), url(${nominee.image})`,
          }
        : {}
    },

    stylesForSuggestion() {
      return {
        backgroundImage: `linear-gradient(0deg, #121212, transparent), url(/static/base_icon.png)`,
      }
    },

    getCategoryName(categoryId) {
      const category = this.$store.state.categories.find((category) => category.id === categoryId)
      return category.name
    },
  },

  computed: {
    selection() {
      // return this.$store.getters.selection.map(({ nominee }) => nominee).filter(nominee => nominee);
      return this.$store.getters.selection
        .map(({ suggestion, nominee }) => ({ suggestion, nominee }))
        .filter(({ suggestion, nominee }) => suggestion || nominee)
    },

    usedCategoryIds() {
      return this.$store.getters.selection
        .map((item) => {
          if (item.nominee && item.nominee.category) {
            return item.nominee.category.id
          }
          if (item.suggestion) {
            return item.suggestion.categoryId
          }
          return undefined
        })
        .filter((categoryId) => categoryId !== undefined)
    },

    categories() {
      return this.$store.state.categories
    },

    round() {
      return this.$store.state.rounds[0]
    },

    canAdd() {
      return this.$store.getters.selection.length > this.selection.length
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Selection.vue